import { Tr, Td, Badge, Text, Tooltip } from "@chakra-ui/react";

const DividendRow = ({ dividend }) => {
  const netAmount = Number(dividend.amount) - Number(dividend.tax);

  return (
    <Tr
      _hover={{ 
        bg: "green.900", 
        transform: "scale(1.001)",
        boxShadow: "0 2px 8px rgba(0,255,0,0.1)"
      }}
      transition="all 0.2s ease"
      borderBottom="1px solid rgba(72, 187, 120, 0.2)"
      bg="rgba(72, 187, 120, 0.05)"
    >
      <Td textAlign="center" fontSize="sm" color="gray.300">
        {new Date(dividend.date).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        })}
      </Td>

      <Td textAlign="center">
        <Badge colorScheme="green" fontSize="xs" px={2} py={1} borderRadius="md">
          {dividend.ticker}
        </Badge>
      </Td>

      <Td textAlign="center" fontSize="xs" color="gray.400" maxW="400px" isTruncated>
        <Tooltip label={dividend.description} hasArrow placement="top">
          {dividend.description}
        </Tooltip>
      </Td>

      <Td textAlign="center" fontWeight="bold" color="green.300" fontSize="sm">
        ${Number(dividend.amount).toFixed(4)}
      </Td>

      <Td textAlign="center" fontWeight="medium" color="red.300" fontSize="sm">
        ${Number(dividend.tax).toFixed(4)}
      </Td>

      <Td textAlign="center" fontWeight="bold" color="teal.300" fontSize="sm">
        <Tooltip label="Amount after tax" hasArrow placement="top">
          ${netAmount.toFixed(4)}
        </Tooltip>
      </Td>
    </Tr>
  );
};

export default DividendRow;